module.exports = __webpack_public_path__ + "static/media/Passenger yachts now.85bdd443.jpg";